import { Component, Input, OnInit } from "@angular/core";
import { EdpModalService } from "@edp-components/edp-modal";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { EnvService } from "@edp-services/env.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "edp-e-more-green-choices-modal",
    templateUrl: "./edp-e-more-green-choices-modal.component.html",
    styleUrls: ["./edp-e-more-green-choices-modal.component.scss"],
})
export class EdpEMoreGreenChoicesModalComponent implements OnInit {
    @Input() public data: IModalData;
    public image: string;

    constructor(
        private readonly edpModalService: EdpModalService,
        private readonly translateService: TranslateService,
        private envService: EnvService,
    ) {}

    ngOnInit(): void {
        this.image = `${this.envService.appUrl()}/resource/image/${this.translateService.instant(
            "pt.edp.edponline.edpe.more.green.options.image"
        )}`;
    }

    public close(knowMore: boolean = false): void {
        this.edpModalService.close(knowMore);
    }
}
